import { routeInfoPRDC, routeInfoCSR } from '../router'
import { factoryOptions } from '../utils/selectOptions'
import {
  getProduct,
  postProduct,
  updateProduct,
  getCustomer,
  postCsr,
  updateCsr
} from '../api'
import { Message } from 'element-ui'

const tplProduct = {
  id: 0,
  code: '',
  originCode: '',
  helperCode: '',
  name: '',
  unit: '',
  comments: '',
  category: '',
  brand: '',
  manufacturer: '',
  auto_parts_type: 0,
  tag1: '',
  tag2: '',
  tag3: '',
  tag4: '',
  standardPrice: '',
  classAPrice: '',
  classBPrice: '',
  classCPrice: '',
  classDPrice: '',
  classEPrice: '',
  ref_pur: '',
  specialPrice: '',
  is_special: '',
  is_clearence: '',
  is_customer_show: '',
  tyreModel: '',
  specification: '',
  diameter: '',
  patterns: '',
  width: '',
  load_rate: '',
  speed_rate: '',
  suggested: '',
  rim_diameter: '',
  rim_width: '',
  offset: '',
  center_bore: '',
  bolt_pattern: '',
  material: ''
}

const tplCsr = {
  id: 0,
  name: '',
  code: '',
  loginShop: '',
  email: '',
  origin_code: '',
  attention: '',
  primary_person_first: '',
  primary_person_last: '',
  phone: '',
  mobile: '',
  skype: '',
  birthday: '',
  note: '',
  website: '',
  address: '',
  city: '',
  state: '',
  postal: '',
  country: '',
  account: '',
  credit_limit: '',
  is_supplier: '',
  branch_flag: '',
  price_strategy: '',
  payment_type: '',
  area_type: '',
  csr_level: '',
  business_type: '',
  default_ship_type: '',
  bd_id: '',
  cs_id: ''
}
export default {
  namespaced: true,
  state: {
    boolSelect: [{ value: 0, label: 'No' }, { value: 1, label: 'Yes' }],
    priceStrategy: [
      { value: 'Standard', label: 'VIP Price' },
      { value: 'Class A', label: 'Class A / COD' },
      { value: 'Class B', label: 'Class B' },
      { value: 'Class C', label: 'Class C' },
      { value: 'Class D', label: 'Class D' },
      { value: 'Class E', label: 'Class E' },
      { value: 'OCOP', label: 'OCOP' }
    ],
    paymentType: [
      { value: 'COD+CHQ', label: 'COD+CHQ' },
      { value: 'COD+Transfer', label: 'COD+Transfer' },
      { value: 'COD+EFT', label: 'COD+EFT' },
      { value: 'COD+POS', label: 'COD+POS' },
      { value: 'COD+CASH', label: 'COD+CASH' },
      { value: 'COD+Card', label: 'COD+Card' },
      { value: 'COD', label: 'COD' },
      { value: 'MUST COD', label: 'MUST COD' },
      { value: 'CHQ', label: 'CHQ' },
      { value: 'CBD', label: 'CBD' },
      { value: 'Card Deduction', label: 'Card Deduction' },
      { value: 'Weekly', label: 'Weekly' },
      { value: 'Fortnightly', label: 'Fortnightly' },
      { value: 'Monthly', label: 'Monthly' },
      { value: '30-Days', label: '30-Days' },
      { value: 'Transfer Themselves', label: 'Transfer Themselves' },
      { value: 'Other', label: 'Other' }
    ],
    tag1Type: [
      { value: 'PCR', label: 'PCR' },
      { value: 'UHP', label: 'UHP' },
      { value: 'SUV H/T', label: 'SUV H/T' },
      { value: 'SUV A/T', label: 'SUV A/T' },
      { value: 'SUV M/T', label: 'SUV M/T' },
      { value: 'COMM', label: 'COMM' },
      { value: 'LT', label: 'LT' },
      { value: 'TBR', label: 'TBR' },
      { value: 'SEMI-SLICK', label: 'SEMI-SLICK' }
    ],
    factoryOptions: factoryOptions,
    businessType: [
      { value: 'Retailer', label: 'Retailer' },
      { value: 'Wholesaler', label: 'Wholesaler' },
      { value: 'Affiliate Client', label: 'Affiliate Client' },
      { value: 'Enterprise Client', label: 'Enterprise Client' },
      { value: 'Cash Buyer', label: 'Cash Buyer' },
      { value: 'Car saler', label: 'Car saler' },
      { value: 'End User', label: 'End User' }
    ],
    shipType: [
      { value: 'Delivery', label: 'Delivery' },
      { value: 'Pick up', label: 'Pick up' }
    ],
    product: {},
    customer: {},
    xeroSent: ''
  },
  getters: {
    areaTypes: (state, getters, rootState, rootGetters) =>
      rootState.areaTypes.map(at => ({
        value: at.name,
        label: at.label
      })),
    csrPriceStrategies: state => [
      { value: 0, label: 'All' },
      ...state.priceStrategy
    ],
    csrBusinessTypes: state => [
      { value: 0, label: 'All' },
      ...state.businessType
    ],
    csrPaymentTypes: state => [
      { value: 0, label: 'All' },
      ...state.paymentType
    ],
    prodTag1Type: state => [
      ...state.tag1Type
    ],
    facOptions: state => [
      ...state.factoryOptions
    ],
    csrAreaTypes: (state, getters, rootState, rootGetters) => {
      const types = rootState.areaTypes.map(at => ({
        value: at.name,
        label: at.label
      }))
      types.unshift({ value: 0, label: 'All' })
      return types
    }
  },
  mutations: {
    init: (state, routeName) => {
      // deep copy tpl here
      switch (routeName) {
        case routeInfoPRDC:
          state.product = JSON.parse(JSON.stringify(tplProduct))
          break
        case routeInfoCSR:
          state.customer = JSON.parse(JSON.stringify(tplCsr))
          break
      }
    },
    setProductId: (state, id = 0) => (state.product.id = id),
    setProductCode: (state, code = '') => (state.product.code = code),
    setOriginCode: (state, code = '') => (state.product.originCode = code),
    setHelperCode: (state, code = '') => (state.product.helperCode = code),
    setProductUnit: (state, code = '') => (state.product.unit = code),
    setProductName: (state, code = '') => (state.product.name = code),
    setProductComment: (state, code = '') => (state.product.comments = code),
    setProductCategory: (state, code = '') => (state.product.category = code),
    setProductbrand: (state, code = '') => (state.product.brand = code),
    setProductManufacturer: (state, code = '') =>
      (state.product.manufacturer = code),
    setProductAutoPartsType: (state, code = '') =>
      (state.product.auto_parts_type = code),
    setProductTag1: (state, code = '') => (state.product.tag1 = code),
    setProductTag2: (state, code = '') => (state.product.tag2 = code),
    setProductTag3: (state, code = '') => (state.product.tag3 = code),
    setProductTag4: (state, code = '') => (state.product.tag4 = code),
    setProductStandardPrice: (state, code = '') =>
      (state.product.standardPrice = code),
    setProductAPrice: (state, code = '') => (state.product.classAPrice = code),
    setProductBPrice: (state, code = '') => (state.product.classBPrice = code),
    setProductCPrice: (state, code = '') => (state.product.classCPrice = code),
    setProductDPrice: (state, code = '') => (state.product.classDPrice = code),
    setProductEPrice: (state, code = '') => (state.product.classEPrice = code),
    setProductRefPurPrice: (state, code = '') => (state.product.ref_pur = code),
    setProductSpecialPrice: (state, code = '') =>
      (state.product.specialPrice = code),
    setProductIsSpecial: (state, code = '') =>
      (state.product.is_special = code),
    setProductIsClearance: (state, code = '') =>
      (state.product.is_clearence = code),
    setProductIsCustomerShow: (state, code = '') =>
      (state.product.is_customer_show = code),
    setProductTyreModel: (state, code = '') => (state.product.tyreModel = code),
    setProductSpecification: (state, code = '') =>
      (state.product.specification = code),
    setProductDiameter: (state, code = '') => (state.product.diameter = code),
    setProductPatterns: (state, code = '') => (state.product.patterns = code),
    setProductWidth: (state, code = '') => (state.product.width = code),
    setProductLoadRate: (state, code = '') => (state.product.load_rate = code),
    setProductSpeedRate: (state, code = '') =>
      (state.product.speed_rate = code),
    setProductSuggested: (state, code = '') => (state.product.suggested = code),
    setProductRimDiameter: (state, code = '') => (state.product.rim_diameter = code),
    setProductRimWidth: (state, code = '') => (state.product.rim_width = code),
    setProductOffset: (state, code = '') => (state.product.offset = code),
    setProductCenterBore: (state, code = '') => (state.product.center_bore = code),
    setProductBoltPattern: (state, code = '') => (state.product.bolt_pattern = code),
    setProductMaterial: (state, code = '') => (state.product.material = code),
    setXeroSent: (state, code = '') => (state.xeroSent = code),
    setCsrId: (state, id = 0) => (state.customer.id = id),
    setCsrName: (state, code = '') => (state.customer.name = code),
    setCsrLoginShop: (state, code = '') => (state.customer.loginShop = code),
    setCsrEmail: (state, code = '') => (state.customer.email = code),
    setCsrContactId: (state, code = '') => (state.customer.code = code),
    setCsrOriginCode: (state, code = '') => (state.customer.origin_code = code),
    setCsrAttention: (state, code = '') => (state.customer.attention = code),
    setCsrFirstName: (state, code = '') =>
      (state.customer.primary_person_first = code),
    setCsrLastName: (state, code = '') =>
      (state.customer.primary_person_last = code),
    setCsrPhone: (state, code = '') => (state.customer.phone = code),
    setCsrMobile: (state, code = '') => (state.customer.mobile = code),
    setCsrSkype: (state, code = '') => (state.customer.skype = code),
    setCsrBirthday: (state, code = '') => (state.customer.birthday = code),
    setCsrNote: (state, code = '') => (state.customer.note = code),
    setCsrWebSite: (state, code = '') => (state.customer.website = code),
    setCsrAddress: (state, code = '') => (state.customer.address = code),
    setCsrCity: (state, code = '') => (state.customer.city = code),
    setCsrState: (state, code = '') => (state.customer.state = code),
    setCsrZip: (state, code = '') => (state.customer.postal = code),
    setCsrCountry: (state, code = '') => (state.customer.country = code),
    setCsrAccount: (state, code = '') => (state.customer.account = code),
    setCsrCreditLimit: (state, code = '') =>
      (state.customer.credit_limit = code),
    setCsrIsSupplier: (state, code = '') => (state.customer.is_supplier = code),
    setCsrBranch: (state, code = '') => (state.customer.branch_flag = code),
    setCsrPriceStrategy: (state, code = '') =>
      (state.customer.price_strategy = code),
    setCsrPayment: (state, code = '') => (state.customer.payment_type = code),
    setCsrArea: (state, code = '') => (state.customer.area_type = code),
    setCsrLevel: (state, code = '') => (state.customer.csr_level = code),
    setCsrBusiness: (state, code = '') => (state.customer.business_type = code),
    setCsrShipType: (state, code = '') =>
      (state.customer.default_ship_type = code),
    setCsrBd: (state, code = '') => (state.customer.bd_id = code),
    setCsrCs: (state, code = '') => (state.customer.cs_id = code)
  },
  actions: {
    initConfig: (context, { routeName, opType }) => {
      switch (routeName) {
        case routeInfoPRDC:
          context.commit('config/setInfoPrdc', opType, { root: true })
          break
        case routeInfoCSR:
          context.commit('config/setInfoCsr', opType, { root: true })
          break
      }
    },
    initEdit: async (context, { routeName, id }) => {
      context.commit('init', routeName)
      await context.dispatch('initConfig', { routeName, opType: 'edit' })
      switch (routeName) {
        case routeInfoPRDC:
          await context.dispatch('loadProduct', id)
          break
        case routeInfoCSR:
          await context.dispatch('loadCsr', id)
          break
      }
    },
    initAdd: async (context, routeName) => {
      context.commit('init', routeName)
      await context.dispatch('initConfig', { routeName, opType: 'add' })
    },
    loadProduct: async (context, id) => {
      const product = (await getProduct(id)).data
      context.commit('setProductId', product.id)
      context.commit('setProductCode', product.code)
      context.commit('setOriginCode', product.originCode)
      context.commit('setHelperCode', product.helperCode)
      context.commit('setProductUnit', product.unit)
      context.commit('setProductName', product.name)
      // context.commit('setProductComment', product.category)
      context.commit('setProductCategory', product.category)
      context.commit('setProductbrand', product.brand)
      context.commit('setProductManufacturer', product.manufacturer)
      context.commit('setProductTag1', product.tag1)
      context.commit('setProductTag2', product.tag2)
      context.commit('setProductTag3', product.tag3)
      context.commit('setProductTag4', product.tag4)
      context.commit('setProductStandardPrice', product.standardPrice)
      context.commit('setProductAPrice', product.classAPrice)
      context.commit('setProductBPrice', product.classBPrice)
      context.commit('setProductCPrice', product.classCPrice)
      context.commit('setProductDPrice', product.classDPrice)
      context.commit('setProductEPrice', product.classEPrice)
      context.commit('setProductRefPurPrice', product.ref_pur)
      context.commit('setProductSpecialPrice', product.specialPrice)
      context.commit('setProductIsSpecial', product.is_special)
      context.commit('setProductIsClearance', product.is_clearance)
      context.commit('setProductIsCustomerShow', product.is_customer_show)
      context.commit('setProductTyreModel', product.tyreModel)
      context.commit('setProductSpecification', product.specification)
      context.commit('setProductDiameter', product.diameter)
      context.commit('setProductPatterns', product.patterns)
      context.commit('setProductWidth', product.width)
      context.commit('setProductLoadRate', product.load_rate)
      context.commit('setProductSpeedRate', product.speed_rate)
      context.commit('setProductSuggested', product.suggested)
      context.commit('setXeroSent', product.xeroSent)
      //  set auto part
      context.commit('setProductAutoPartsType', product.auto_parts_type)
      context.commit('setProductRimDiameter', product.rim_diameter)
      context.commit('setProductRimWidth', product.rim_width)
      context.commit('setProductOffset', product.offset)
      context.commit('setProductCenterBore', product.center_bore)
      context.commit('setProductBoltPattern', product.bolt_pattern)
      context.commit('setProductMaterial', product.material)
    },
    loadCsr: async (context, id) => {
      const csr = (await getCustomer(id)).data
      context.commit('setCsrId', csr.id)
      context.commit('setCsrName', csr.name)
      context.commit('setCsrLoginShop', csr.loginShop)
      context.commit('setCsrEmail', csr.email)
      context.commit('setCsrContactId', csr.code)
      context.commit('setCsrOriginCode', csr.origin_code)
      context.commit('setCsrAttention', csr.attention)
      context.commit('setCsrFirstName', csr.primary_person_first)
      context.commit('setCsrLastName', csr.primary_person_last)
      context.commit('setCsrPhone', csr.phone)
      context.commit('setCsrMobile', csr.mobile)
      context.commit('setCsrSkype', csr.skype)
      context.commit('setCsrBirthday', csr.birthday)
      context.commit('setCsrNote', csr.note)
      context.commit('setCsrWebSite', csr.website)
      context.commit('setCsrAddress', csr.address)
      context.commit('setCsrCity', csr.city)
      context.commit('setCsrState', csr.state)
      context.commit('setCsrZip', csr.postal)
      context.commit('setCsrCountry', csr.country)
      context.commit('setCsrAccount', csr.account)
      context.commit('setCsrCreditLimit', csr.creditLimit)
      context.commit('setCsrIsSupplier', csr.is_supplier)
      context.commit('setCsrBranch', csr.branch_flag)
      context.commit('setCsrPriceStrategy', csr.priceType)
      context.commit('setCsrPayment', csr.paymentType)
      context.commit('setCsrArea', csr.areaType)
      context.commit('setCsrLevel', csr.csrLevel)
      context.commit('setCsrBusiness', csr.businessType)
      context.commit('setCsrShipType', csr.default_ship_type)
      context.commit('setCsrBd', csr.bd_id)
      context.commit('setCsrCs', csr.cs_id)
      context.commit('setXeroSent', csr.xeroSent)
    },
    submitProduct: async context => {
      let data
      if (context.state.product.name.length > 50) {
        Message.warning({
          showClose: true,
          duration: 3500,
          dangerouslyUseHTMLString: true,
          message: 'The product name should not exceed 50 characters.'
        })
        return
      }
      const params = { ...context.state.product }

      if (params.id > 0) {
        data = await updateProduct(params.id, params)
      } else {
        data = await postProduct(params)
      }
      return data
    },
    submitCsr: async context => {
      let data
      const params = { ...context.state.customer }

      if (params.id > 0) {
        data = await updateCsr(params.id, params)
      } else {
        data = await postCsr(params)
      }
      return data
    }
  }
}
